import { useQuery } from '@tanstack/react-query'
import { settingsService } from '@/lib/services/settings'

// Shares the ['settings'] cache entry Layout already populates, so this is a
// cache read at every call site rather than four separate fetches.
export function usePersonalTasksEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000,
  })
  return Boolean((data as any)?.userAccess?.personalTasks?.enabled)
}
